<template>
    <card>
        <div>
            <div class="row">
                <div class="col-md-12">

                    <h3 class="text-center text-muted">Lajmërimet e fundit</h3>
                    <iframe id="showiframe" src="" v-if="iframe" style="height: 600px; width: 100%;">
                    </iframe>
                    <div class="alert alert-info alert-with-icon shadow-sm bg-light rounded text-dark"
                        data-notify="container" v-for="item in njoftimet" :key="item.id" id="show_notification">
                        <span class="float-right">{{ item.data }}</span>
                        <span data-notify="icon" class="ti-announcement"></span>
                        <span data-notify="message"> <a :href="item.porosia" target="_blank" class="text-dark">{{
                            item.titulli }}</a></span>
                    </div>
                </div>

            </div>

        </div>
    </card>
</template>

<script>
import moment from 'moment'
import { APISettings } from '../api/config.js'

export default {
    data()
    {
        return {
            njoftimet: [],
            iframe: false,
        }

    },
    methods: {
        getData()
        {
            this.loader = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Njoftimet/getNjoftimetStudent/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {

                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {
                                res.forEach((obj) =>
                                {
                                    const formattedDate = moment(obj.data).format('DD/MM/YYYY');
                                    obj.data = formattedDate;
                                    this.njoftimet = res;
                                    console.log(this.njoftimet);
                                    if (obj.titulli === undefined)
                                    {
                                        obj.titulli = "Kliko ketu"
                                    }
                                });
                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                            this.loader = false;
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },
        navigate(a)
        {
            this.iframe = true;
            document.getElementById("showiframe").src = a;

        }
    },

    beforeMount()
    {
        this.getData();
    },

}
</script>

<style></style>
